import "../../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import ht from "./styles/index.cssr.js";
import Q from "../../../_mixins/use-theme.js";
import vt from "../../../_mixins/use-config.js";
import { useRtl as bt } from "../../../_mixins/use-rtl.js";
import pt from "../styles/light.js";
import { render as D } from "../../../_utils/vue/render.js";
import { createKey as X } from "../../../_utils/cssr/index.js";
import { getMargin as Y } from "../../../../../../../seemly@0.3.10/node_modules/seemly/es/css/index.js";
import { useThemeClass as gt } from "../../../_mixins/use-css-vars-class.js";
import mt from "../../suffix/src/Suffix.js";
import { Wrapper as wt } from "../../../_utils/vue/wrapper.js";
import K from "../../../tag/src/Tag.js";
import Z from "../../../../../../../vueuc@0.4.64_vue@3.5.18/node_modules/vueuc/es/overflow/src/index.js";
import Ct from "../../../popover/src/Popover.js";
import { getTitleAttribute as ee } from "../../../_utils/naive/attribute.js";
import { defineComponent as xt, computed as T, watch as N, nextTick as yt, onMounted as It, watchEffect as Pt, h as l, Fragment as Rt } from "../../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as a, toRef as V } from "../../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { useOnResize as Tt } from "../../../_utils/composable/use-resize.js";
const Ut = xt({
  name: "InternalSelection",
  props: Object.assign(Object.assign({}, Q.props), {
    clsPrefix: {
      type: String,
      required: !0
    },
    bordered: {
      type: Boolean,
      default: void 0
    },
    active: Boolean,
    pattern: {
      type: String,
      default: ""
    },
    placeholder: String,
    selectedOption: {
      type: Object,
      default: null
    },
    selectedOptions: {
      type: Array,
      default: null
    },
    labelField: {
      type: String,
      default: "label"
    },
    valueField: {
      type: String,
      default: "value"
    },
    multiple: Boolean,
    filterable: Boolean,
    clearable: Boolean,
    disabled: Boolean,
    size: {
      type: String,
      default: "medium"
    },
    loading: Boolean,
    autofocus: Boolean,
    showArrow: {
      type: Boolean,
      default: !0
    },
    inputProps: Object,
    focused: Boolean,
    renderTag: Function,
    onKeydown: Function,
    onClick: Function,
    onBlur: Function,
    onFocus: Function,
    onDeleteOption: Function,
    maxTagCount: [String, Number],
    ellipsisTagPopoverProps: Object,
    onClear: Function,
    onPatternInput: Function,
    onPatternFocus: Function,
    onPatternBlur: Function,
    renderLabel: Function,
    status: String,
    inlineThemeDisabled: Boolean,
    ignoreComposition: {
      type: Boolean,
      default: !0
    },
    onResize: Function
  }),
  setup(t) {
    const {
      mergedClsPrefixRef: _,
      mergedRtlRef: F
    } = vt(t), c = bt("InternalSelection", F, _), p = a(null), s = a(null), y = a(null), o = a(null), O = a(null), g = a(null), f = a(null), h = a(null), m = a(null), w = a(null), C = a(!1), u = a(!1), x = a(!1), v = Q("InternalSelection", "-internal-selection", ht, pt, t, V(t, "clsPrefix")), d = T(() => t.clearable && !t.disabled && (x.value || t.active)), b = T(() => t.selectedOption ? t.renderTag ? t.renderTag({
      option: t.selectedOption,
      handleClose: () => {
      }
    }) : t.renderLabel ? t.renderLabel(t.selectedOption, !0) : D(t.selectedOption[t.labelField], t.selectedOption, !0) : t.placeholder), E = T(() => {
      const e = t.selectedOption;
      if (e)
        return e[t.labelField];
    }), I = T(() => t.multiple ? !!(Array.isArray(t.selectedOptions) && t.selectedOptions.length) : t.selectedOption !== null);
    function P() {
      var e;
      const {
        value: n
      } = p;
      if (n) {
        const {
          value: i
        } = s;
        i && (i.style.width = `${n.offsetWidth}px`, t.maxTagCount !== "responsive" && ((e = m.value) === null || e === void 0 || e.sync({
          showAllItemsBeforeCalculate: !1
        })));
      }
    }
    function S() {
      const {
        value: e
      } = w;
      e && (e.style.display = "none");
    }
    function A() {
      const {
        value: e
      } = w;
      e && (e.style.display = "inline-block");
    }
    N(V(t, "active"), (e) => {
      e || S();
    }), N(V(t, "pattern"), () => {
      t.multiple && yt(P);
    });
    function W(e) {
      const {
        onFocus: n
      } = t;
      n && n(e);
    }
    function U(e) {
      const {
        onBlur: n
      } = t;
      n && n(e);
    }
    function k(e) {
      const {
        onDeleteOption: n
      } = t;
      n && n(e);
    }
    function B(e) {
      const {
        onClear: n
      } = t;
      n && n(e);
    }
    function r(e) {
      const {
        onPatternInput: n
      } = t;
      n && n(e);
    }
    function te(e) {
      var n;
      (!e.relatedTarget || !(!((n = y.value) === null || n === void 0) && n.contains(e.relatedTarget))) && W(e);
    }
    function ne(e) {
      var n;
      !((n = y.value) === null || n === void 0) && n.contains(e.relatedTarget) || U(e);
    }
    function oe(e) {
      B(e);
    }
    function le() {
      x.value = !0;
    }
    function ie() {
      x.value = !1;
    }
    function re(e) {
      !t.active || !t.filterable || e.target !== s.value && e.preventDefault();
    }
    function q(e) {
      k(e);
    }
    const $ = a(!1);
    function ae(e) {
      if (e.key === "Backspace" && !$.value && !t.pattern.length) {
        const {
          selectedOptions: n
        } = t;
        n != null && n.length && q(n[n.length - 1]);
      }
    }
    let L = null;
    function se(e) {
      const {
        value: n
      } = p;
      if (n) {
        const i = e.target.value;
        n.textContent = i, P();
      }
      t.ignoreComposition && $.value ? L = e : r(e);
    }
    function ue() {
      $.value = !0;
    }
    function de() {
      $.value = !1, t.ignoreComposition && r(L), L = null;
    }
    function ce(e) {
      var n;
      u.value = !0, (n = t.onPatternFocus) === null || n === void 0 || n.call(t, e);
    }
    function fe(e) {
      var n;
      u.value = !1, (n = t.onPatternBlur) === null || n === void 0 || n.call(t, e);
    }
    function he() {
      var e, n;
      if (t.filterable)
        u.value = !1, (e = g.value) === null || e === void 0 || e.blur(), (n = s.value) === null || n === void 0 || n.blur();
      else if (t.multiple) {
        const {
          value: i
        } = o;
        i == null || i.blur();
      } else {
        const {
          value: i
        } = O;
        i == null || i.blur();
      }
    }
    function ve() {
      var e, n, i;
      t.filterable ? (u.value = !1, (e = g.value) === null || e === void 0 || e.focus()) : t.multiple ? (n = o.value) === null || n === void 0 || n.focus() : (i = O.value) === null || i === void 0 || i.focus();
    }
    function be() {
      const {
        value: e
      } = s;
      e && (A(), e.focus());
    }
    function pe() {
      const {
        value: e
      } = s;
      e && e.blur();
    }
    function ge(e) {
      const {
        value: n
      } = f;
      n && n.setTextContent(`+${e}`);
    }
    function me() {
      const {
        value: e
      } = h;
      return e;
    }
    function we() {
      return s.value;
    }
    let j = null;
    function H() {
      j !== null && window.clearTimeout(j);
    }
    function Ce() {
      t.active || (H(), j = window.setTimeout(() => {
        I.value && (C.value = !0);
      }, 100));
    }
    function xe() {
      H();
    }
    function ye(e) {
      e || (H(), C.value = !1);
    }
    N(I, (e) => {
      e || (C.value = !1);
    }), It(() => {
      Pt(() => {
        const e = g.value;
        e && (t.disabled ? e.removeAttribute("tabindex") : e.tabIndex = u.value ? -1 : 0);
      });
    }), Tt(y, t.onResize);
    const {
      inlineThemeDisabled: G
    } = t, J = T(() => {
      const {
        size: e
      } = t, {
        common: {
          cubicBezierEaseInOut: n
        },
        self: {
          fontWeight: i,
          borderRadius: Ie,
          color: Pe,
          placeholderColor: Re,
          textColor: Te,
          paddingSingle: Fe,
          paddingMultiple: Oe,
          caretColor: $e,
          colorDisabled: _e,
          textColorDisabled: Ee,
          placeholderColorDisabled: Se,
          colorActive: Be,
          boxShadowFocus: Me,
          boxShadowActive: ze,
          boxShadowHover: De,
          border: Ae,
          borderFocus: We,
          borderHover: ke,
          borderActive: Le,
          arrowColor: je,
          arrowColorDisabled: He,
          loadingColor: Ke,
          // form warning
          colorActiveWarning: Ne,
          boxShadowFocusWarning: Ve,
          boxShadowActiveWarning: Ue,
          boxShadowHoverWarning: qe,
          borderWarning: Ge,
          borderFocusWarning: Je,
          borderHoverWarning: Qe,
          borderActiveWarning: Xe,
          // form error
          colorActiveError: Ye,
          boxShadowFocusError: Ze,
          boxShadowActiveError: et,
          boxShadowHoverError: tt,
          borderError: nt,
          borderFocusError: ot,
          borderHoverError: lt,
          borderActiveError: it,
          // clear
          clearColor: rt,
          clearColorHover: at,
          clearColorPressed: st,
          clearSize: ut,
          // arrow
          arrowSize: dt,
          [X("height", e)]: ct,
          [X("fontSize", e)]: ft
        }
      } = v.value, M = Y(Fe), z = Y(Oe);
      return {
        "--n-bezier": n,
        "--n-border": Ae,
        "--n-border-active": Le,
        "--n-border-focus": We,
        "--n-border-hover": ke,
        "--n-border-radius": Ie,
        "--n-box-shadow-active": ze,
        "--n-box-shadow-focus": Me,
        "--n-box-shadow-hover": De,
        "--n-caret-color": $e,
        "--n-color": Pe,
        "--n-color-active": Be,
        "--n-color-disabled": _e,
        "--n-font-size": ft,
        "--n-height": ct,
        "--n-padding-single-top": M.top,
        "--n-padding-multiple-top": z.top,
        "--n-padding-single-right": M.right,
        "--n-padding-multiple-right": z.right,
        "--n-padding-single-left": M.left,
        "--n-padding-multiple-left": z.left,
        "--n-padding-single-bottom": M.bottom,
        "--n-padding-multiple-bottom": z.bottom,
        "--n-placeholder-color": Re,
        "--n-placeholder-color-disabled": Se,
        "--n-text-color": Te,
        "--n-text-color-disabled": Ee,
        "--n-arrow-color": je,
        "--n-arrow-color-disabled": He,
        "--n-loading-color": Ke,
        // form warning
        "--n-color-active-warning": Ne,
        "--n-box-shadow-focus-warning": Ve,
        "--n-box-shadow-active-warning": Ue,
        "--n-box-shadow-hover-warning": qe,
        "--n-border-warning": Ge,
        "--n-border-focus-warning": Je,
        "--n-border-hover-warning": Qe,
        "--n-border-active-warning": Xe,
        // form error
        "--n-color-active-error": Ye,
        "--n-box-shadow-focus-error": Ze,
        "--n-box-shadow-active-error": et,
        "--n-box-shadow-hover-error": tt,
        "--n-border-error": nt,
        "--n-border-focus-error": ot,
        "--n-border-hover-error": lt,
        "--n-border-active-error": it,
        // clear
        "--n-clear-size": ut,
        "--n-clear-color": rt,
        "--n-clear-color-hover": at,
        "--n-clear-color-pressed": st,
        // arrow-size
        "--n-arrow-size": dt,
        // font-weight
        "--n-font-weight": i
      };
    }), R = G ? gt("internal-selection", T(() => t.size[0]), J, t) : void 0;
    return {
      mergedTheme: v,
      mergedClearable: d,
      mergedClsPrefix: _,
      rtlEnabled: c,
      patternInputFocused: u,
      filterablePlaceholder: b,
      label: E,
      selected: I,
      showTagsPanel: C,
      isComposing: $,
      // dom ref
      counterRef: f,
      counterWrapperRef: h,
      patternInputMirrorRef: p,
      patternInputRef: s,
      selfRef: y,
      multipleElRef: o,
      singleElRef: O,
      patternInputWrapperRef: g,
      overflowRef: m,
      inputTagElRef: w,
      handleMouseDown: re,
      handleFocusin: te,
      handleClear: oe,
      handleMouseEnter: le,
      handleMouseLeave: ie,
      handleDeleteOption: q,
      handlePatternKeyDown: ae,
      handlePatternInputInput: se,
      handlePatternInputBlur: fe,
      handlePatternInputFocus: ce,
      handleMouseEnterCounter: Ce,
      handleMouseLeaveCounter: xe,
      handleFocusout: ne,
      handleCompositionEnd: de,
      handleCompositionStart: ue,
      onPopoverUpdateShow: ye,
      focus: ve,
      focusInput: be,
      blur: he,
      blurInput: pe,
      updateCounter: ge,
      getCounter: me,
      getTail: we,
      renderLabel: t.renderLabel,
      cssVars: G ? void 0 : J,
      themeClass: R == null ? void 0 : R.themeClass,
      onRender: R == null ? void 0 : R.onRender
    };
  },
  render() {
    const {
      status: t,
      multiple: _,
      size: F,
      disabled: c,
      filterable: p,
      maxTagCount: s,
      bordered: y,
      clsPrefix: o,
      ellipsisTagPopoverProps: O,
      onRender: g,
      renderTag: f,
      renderLabel: h
    } = this;
    g == null || g();
    const m = s === "responsive", w = typeof s == "number", C = m || w, u = l(wt, null, {
      default: () => l(mt, {
        clsPrefix: o,
        loading: this.loading,
        showArrow: this.showArrow,
        showClear: this.mergedClearable && this.selected,
        onClear: this.handleClear
      }, {
        default: () => {
          var v, d;
          return (d = (v = this.$slots).arrow) === null || d === void 0 ? void 0 : d.call(v);
        }
      })
    });
    let x;
    if (_) {
      const {
        labelField: v
      } = this, d = (r) => l("div", {
        class: `${o}-base-selection-tag-wrapper`,
        key: r.value
      }, f ? f({
        option: r,
        handleClose: () => {
          this.handleDeleteOption(r);
        }
      }) : l(K, {
        size: F,
        closable: !r.disabled,
        disabled: c,
        onClose: () => {
          this.handleDeleteOption(r);
        },
        internalCloseIsButtonTag: !1,
        internalCloseFocusable: !1
      }, {
        default: () => h ? h(r, !0) : D(r[v], r, !0)
      })), b = () => (w ? this.selectedOptions.slice(0, s) : this.selectedOptions).map(d), E = p ? l("div", {
        class: `${o}-base-selection-input-tag`,
        ref: "inputTagElRef",
        key: "__input-tag__"
      }, l("input", Object.assign({}, this.inputProps, {
        ref: "patternInputRef",
        tabindex: -1,
        disabled: c,
        value: this.pattern,
        autofocus: this.autofocus,
        class: `${o}-base-selection-input-tag__input`,
        onBlur: this.handlePatternInputBlur,
        onFocus: this.handlePatternInputFocus,
        onKeydown: this.handlePatternKeyDown,
        onInput: this.handlePatternInputInput,
        onCompositionstart: this.handleCompositionStart,
        onCompositionend: this.handleCompositionEnd
      })), l("span", {
        ref: "patternInputMirrorRef",
        class: `${o}-base-selection-input-tag__mirror`
      }, this.pattern)) : null, I = m ? () => l("div", {
        class: `${o}-base-selection-tag-wrapper`,
        ref: "counterWrapperRef"
      }, l(K, {
        size: F,
        ref: "counterRef",
        onMouseenter: this.handleMouseEnterCounter,
        onMouseleave: this.handleMouseLeaveCounter,
        disabled: c
      })) : void 0;
      let P;
      if (w) {
        const r = this.selectedOptions.length - s;
        r > 0 && (P = l("div", {
          class: `${o}-base-selection-tag-wrapper`,
          key: "__counter__"
        }, l(K, {
          size: F,
          ref: "counterRef",
          onMouseenter: this.handleMouseEnterCounter,
          disabled: c
        }, {
          default: () => `+${r}`
        })));
      }
      const S = m ? p ? l(Z, {
        ref: "overflowRef",
        updateCounter: this.updateCounter,
        getCounter: this.getCounter,
        getTail: this.getTail,
        style: {
          width: "100%",
          display: "flex",
          overflow: "hidden"
        }
      }, {
        default: b,
        counter: I,
        tail: () => E
      }) : l(Z, {
        ref: "overflowRef",
        updateCounter: this.updateCounter,
        getCounter: this.getCounter,
        style: {
          width: "100%",
          display: "flex",
          overflow: "hidden"
        }
      }, {
        default: b,
        counter: I
      }) : w && P ? b().concat(P) : b(), A = C ? () => l("div", {
        class: `${o}-base-selection-popover`
      }, m ? b() : this.selectedOptions.map(d)) : void 0, W = C ? Object.assign({
        show: this.showTagsPanel,
        trigger: "hover",
        overlap: !0,
        placement: "top",
        width: "trigger",
        onUpdateShow: this.onPopoverUpdateShow,
        theme: this.mergedTheme.peers.Popover,
        themeOverrides: this.mergedTheme.peerOverrides.Popover
      }, O) : null, k = (this.selected ? !1 : this.active ? !this.pattern && !this.isComposing : !0) ? l("div", {
        class: `${o}-base-selection-placeholder ${o}-base-selection-overlay`
      }, l("div", {
        class: `${o}-base-selection-placeholder__inner`
      }, this.placeholder)) : null, B = p ? l("div", {
        ref: "patternInputWrapperRef",
        class: `${o}-base-selection-tags`
      }, S, m ? null : E, u) : l("div", {
        ref: "multipleElRef",
        class: `${o}-base-selection-tags`,
        tabindex: c ? void 0 : 0
      }, S, u);
      x = l(Rt, null, C ? l(Ct, Object.assign({}, W, {
        scrollable: !0,
        style: "max-height: calc(var(--v-target-height) * 6.6);"
      }), {
        trigger: () => B,
        default: A
      }) : B, k);
    } else if (p) {
      const v = this.pattern || this.isComposing, d = this.active ? !v : !this.selected, b = this.active ? !1 : this.selected;
      x = l("div", {
        ref: "patternInputWrapperRef",
        class: `${o}-base-selection-label`,
        title: this.patternInputFocused ? void 0 : ee(this.label)
      }, l("input", Object.assign({}, this.inputProps, {
        ref: "patternInputRef",
        class: `${o}-base-selection-input`,
        value: this.active ? this.pattern : "",
        placeholder: "",
        readonly: c,
        disabled: c,
        tabindex: -1,
        autofocus: this.autofocus,
        onFocus: this.handlePatternInputFocus,
        onBlur: this.handlePatternInputBlur,
        onInput: this.handlePatternInputInput,
        onCompositionstart: this.handleCompositionStart,
        onCompositionend: this.handleCompositionEnd
      })), b ? l("div", {
        class: `${o}-base-selection-label__render-label ${o}-base-selection-overlay`,
        key: "input"
      }, l("div", {
        class: `${o}-base-selection-overlay__wrapper`
      }, f ? f({
        option: this.selectedOption,
        handleClose: () => {
        }
      }) : h ? h(this.selectedOption, !0) : D(this.label, this.selectedOption, !0))) : null, d ? l("div", {
        class: `${o}-base-selection-placeholder ${o}-base-selection-overlay`,
        key: "placeholder"
      }, l("div", {
        class: `${o}-base-selection-overlay__wrapper`
      }, this.filterablePlaceholder)) : null, u);
    } else
      x = l("div", {
        ref: "singleElRef",
        class: `${o}-base-selection-label`,
        tabindex: this.disabled ? void 0 : 0
      }, this.label !== void 0 ? l("div", {
        class: `${o}-base-selection-input`,
        title: ee(this.label),
        key: "input"
      }, l("div", {
        class: `${o}-base-selection-input__content`
      }, f ? f({
        option: this.selectedOption,
        handleClose: () => {
        }
      }) : h ? h(this.selectedOption, !0) : D(this.label, this.selectedOption, !0))) : l("div", {
        class: `${o}-base-selection-placeholder ${o}-base-selection-overlay`,
        key: "placeholder"
      }, l("div", {
        class: `${o}-base-selection-placeholder__inner`
      }, this.placeholder)), u);
    return l("div", {
      ref: "selfRef",
      class: [`${o}-base-selection`, this.rtlEnabled && `${o}-base-selection--rtl`, this.themeClass, t && `${o}-base-selection--${t}-status`, {
        [`${o}-base-selection--active`]: this.active,
        [`${o}-base-selection--selected`]: this.selected || this.active && this.pattern,
        [`${o}-base-selection--disabled`]: this.disabled,
        [`${o}-base-selection--multiple`]: this.multiple,
        // focus is not controlled by selection itself since it always need
        // to be managed together with menu. provide :focus style will cause
        // many redundant codes.
        [`${o}-base-selection--focus`]: this.focused
      }],
      style: this.cssVars,
      onClick: this.onClick,
      onMouseenter: this.handleMouseEnter,
      onMouseleave: this.handleMouseLeave,
      onKeydown: this.onKeydown,
      onFocusin: this.handleFocusin,
      onFocusout: this.handleFocusout,
      onMousedown: this.handleMouseDown
    }, x, y ? l("div", {
      class: `${o}-base-selection__border`
    }) : null, y ? l("div", {
      class: `${o}-base-selection__state-border`
    }) : null);
  }
});
export {
  Ut as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_internal/selection/src/Selection.js
// module id = 1567
// module chunks = 41